module.exports = __webpack_public_path__ + "img/BE_BC_Back@2x.341b8ae9.png";